import { Outlet } from "react-router-dom"

const RouteInventario = () => {
    return (
        <Outlet />
    )
}
export default RouteInventario